<template>
  <div class="container">
    <div class="header">
      <div class="header_logo">
        <img
          class="img1"
          src="../../assets/image/zxl_logo.png"
          @click="handleToAdmin"
        />
      </div>
      <div class="header_r">
        <div>
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="item.active ? 'active' : ''"
              @click="handleChangeTitle(index, 'navList')"
            >
              <div class="title">
                <a :href="item.routerPath">
                  {{ item.title }}
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="btn" @click="handleToAdmin">免费试用</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navList: [
        { title: "首页", active: true, routerPath: "#banner" },
        { title: "平台核心优势", active: false, routerPath: "#advantage" },
        { title: "为什么选择我们", active: false, routerPath: "#about_us" },
        { title: "您需要做什么", active: false, routerPath: "#what_do" },
        { title: "入驻加盟", active: false, routerPath: "#franchise" },
        { title: "经纪人成长体系", active: false, routerPath: "#system" },
        { title: "成功案例", active: false, routerPath: "#case" },
      ],
      menuList: [],
      menuHeight: "0px",
    };
  },
  mounted() {
    // 强制滚动到顶部
    let func = this.debounce(this.handleScrollFun, 100);
    window.addEventListener("scroll", func);
    window.localStorage.setItem("versionType", 1);
    this.$store.commit("setVersionType", 1);
  },
  methods: {
    handleChangeTitle(index, list) {
      this[list].forEach((item, i) => {
        if (index == i) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
    },
    handleScrollFun() {
      const sections = [
        { id: "banner", index: 0 },
        { id: "advantage", index: 1 },
        { id: "about_us", index: 2 },
        { id: "what_do", index: 3 },
        { id: "franchise", index: 4 },
        { id: "system", index: 5 },
        { id: "case", index: 6 },
      ];
      const currentPosition = window.scrollY + 100;
      sections.forEach((section) => {
        const anchorPointPosition = document.getElementById(
          section.id
        ).offsetTop;
        const item = this.navList[section.index];
        if (currentPosition > anchorPointPosition) {
          this.navList.forEach((navItem, index) => {
            navItem.active = index === section.index;
          });
        }
      });
    },
    debounce(func, delay) {
      let timerId;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timerId);
        timerId = setTimeout(function () {
          func.apply(context, args);
        }, delay);
      };
    },
    handleToAdmin() {
      window.open("https://saas.manzu365.com");
    },
    handleToAdmin() {
      window.location.href = "http://saas.zuxl.cn";
    },
  },
  computed: {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped lang="scss">
$width: 1200px;
.active {
  position: relative;
  a {
    color: #98ce2a !important;
    transition: all 0.3s ease;
  }
  &::after {
    display: block;
    content: "";
    position: absolute;
    bottom: 5px;
    left: 50%;
    width: 100%;
    height: 5px;
    background: #98ce2a;
    transform: translateX(-50%);
    border-radius: 2px;
  }
}
.container {
  width: 100vw;
  height: 60px;
  display: flex;
  justify-content: center;
  // position: fixed;
  position: sticky;
  top: 0;
  z-index: 999;
  background: #fff;
  .header {
    width: $width;
    height: 60px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 0 50px;
    box-sizing: border-box;
    &_logo {
      display: flex;
      align-items: center;
      column-gap: 19px;
      .img1 {
        width: 144px;
        height: 46px;
        cursor: pointer;
      }
    }
    &_r {
      display: flex;
      align-items: center;
      column-gap: 38px;
    }
    ul {
      display: flex;
      column-gap: 38px;
      height: 60px;
      align-items: center;
      li {
        cursor: pointer;
        font-size: 14px;
        color: #666666;
        transition: all 0.3s ease;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE 10+/Edge */
        user-select: none;
        height: 60px;
        display: flex;
        align-items: center;

        .title {
          height: 100%;
          line-height: 60px;
          position: relative;
          transition: all 0.3s ease;

          a {
            color: #666666;
            text-decoration: none;
            transition: all 0.3s ease;
            &::after {
              display: block;
              content: "";
              position: absolute;
              bottom: 5px;
              left: 50%;
              width: 0px;
              height: 5px;
              background: #98ce2a;
              transform: translateX(-50%);
              border-radius: 2px;
              transition: all 0.3s ease;
            }
          }
          a:hover {
            color: #98ce2a;
            &::after {
              width: 100%;
            }
          }
        }
      }
    }
    .btn {
      width: 100px;
      height: 36px;
      background: #98ce2a;
      border-radius: 20px;
      text-align: center;
      line-height: 36px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      transition: 0.3s ease all;
      animation: freshBreath 2.5s cubic-bezier(0.38, 1.3, 0.5, 1.1) infinite,
        greenShake 3.2s ease-in-out infinite;
    }
  }
}
@keyframes freshBreath {
  0% {
    transform: scale(1);
    background-position: 0% 0%;
  }
  35% {
    transform: scale(1.1);
    background-position: 35% 25%;
  }
  70% {
    transform: scale(1.05);
    background-position: 60% 40%;
  }
  100% {
    transform: scale(1);
    background-position: 0% 0%;
  }
}

@keyframes greenShake {
  0% {
    transform: translateX(0) rotate(0deg);
  }
  3% {
    transform: translateX(-3px) rotate(-2deg);
  }
  7% {
    transform: translateX(3.5px) rotate(2deg);
  }
  11% {
    transform: translateX(-2.8px) rotate(-1.8deg);
  }
  15% {
    transform: translateX(2.5px) rotate(1.5deg);
  }
  19% {
    transform: translateX(-2px) rotate(-1.2deg);
  }
  23% {
    transform: translateX(1.8px) rotate(1deg);
  }
  27% {
    transform: translateX(-1.3px) rotate(-0.8deg);
  }
  31% {
    transform: translateX(0.8px) rotate(0.5deg);
  }
  35% {
    transform: translateX(0) rotate(0deg);
  }
  100% {
    transform: translateX(0) rotate(0deg); /* 静止时间变短，抖动更活跃 */
  }
}
</style>
